module.exports = __webpack_public_path__ + "static/pakmaya-ppd-web-6ff718b803a9b021da83423465174762.jpg";